import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import { red } from '@material-ui/core/colors';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Timer } from '../custom/Timer';




const useStyles = makeStyles((theme) => ({
  root: {
    width: '80%',
    margin: 'auto',
    maxWidth: 800
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

const ProjectSummary = ({ id, title, content, createdAt, manager, assignee, endDateTime, complete }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <div>
      <Card style={{ marginBottom: 20, marginTop: -3 }}>
        <CardHeader style={{ padding: 10 }}
          avatar={
            <Avatar aria-label="recipe" className={classes.avatar}>P</Avatar>
          }
          action={
            <Link to={'/project/' + id} key={id}>
              <IconButton aria-label="settings">
                <OpenInNewIcon />
              </IconButton>
            </Link>
          }
          title={title}
          subheader={moment(createdAt.toDate()).calendar()}
        />
        <CardContent style={{ padding: 10, position:'relative' }}>
        <Timer noAbsolute endDateTime={endDateTime} complete={complete} />
          <div>
            <strong>Project Manager</strong> : {manager.displayName}
          </div>

          <div>
            <strong>Project assignee</strong> :
                {
              assignee.map((user, i) => {
                return <span key={user.id}> {i != 0 && ','} {user.displayName}</span>
              })
            }
          </div>
        </CardContent>
        <CardActions disableSpacing style={{ padding: 0 }}>
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded,
            })}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </IconButton>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <p><strong>Project Description</strong></p>
            <div dangerouslySetInnerHTML={{ __html: content }}></div>
          </CardContent>
        </Collapse>
      </Card>
    </div>
  )
}

export default ProjectSummary